import { ConditionFactory } from '../Factory/ConditionFactory';
import { WidgetFactory } from '../Factory/WidgetFactory';
import { TriggerAction } from '../Model/TriggerAction';
import { WidgetType } from '../Model/WidgetType';
/* tslint:disable:no-any */
var DesktopStrategy = /** @class */ (function () {
    function DesktopStrategy(config) {
        this._pageLeaveWidgets = [];
        this.config = config;
    }
    DesktopStrategy.prototype.isSame = function (strategy) {
        return strategy instanceof DesktopStrategy;
    };
    DesktopStrategy.prototype.build = function () {
        var _this = this;
        var pageLeaveSetting = this.config.setting && this.config.setting.pageLeave && this.config.setting.pageLeave.desktop;
        var pageOpenSetting = this.config.setting && this.config.setting.pageOpen && this.config.setting.pageOpen.desktop;
        if (!pageOpenSetting && !pageLeaveSetting) {
            return;
        }
        var pageOpenWidgets = [];
        this.config.groups.forEach(function (group) {
            if (group.widgets && group.widgets.length) {
                group.widgets.forEach(function (model) {
                    var conditions = ConditionFactory.build(model.behavior.conditions);
                    if (!conditions.every(function (condition) { return condition.canBeCached || condition.check(); })) {
                        return;
                    }
                    switch (model.triggerAction) {
                        case TriggerAction.PageOpen:
                            pageOpenWidgets.push(WidgetFactory.build(model, pageOpenSetting.behavior, _this.config.hosts, _this.config.language, group));
                            break;
                        case TriggerAction.PageLeave:
                            var widget = WidgetFactory.build(model, pageLeaveSetting.behavior, _this.config.hosts, _this.config.language, group);
                            _this._pageLeaveWidgets.push(widget);
                            widget.register();
                            break;
                        default:
                            return;
                    }
                });
            }
        });
        if (!pageOpenWidgets.length) {
            return;
        }
        this._pageOpenWidget = pageOpenWidgets.length > 1
            ? this.buildSliderWidget(pageOpenSetting, pageOpenWidgets)
            : pageOpenWidgets[0];
        this._pageOpenWidget.register();
    };
    DesktopStrategy.prototype.buildSliderWidget = function (setting, widgets) {
        var widgetModel = {
            type: WidgetType.Slider,
            slides: widgets.sort(function (a, b) { return a.sort - b.sort; })
        };
        return WidgetFactory.build(widgetModel, setting.behavior, this.config.hosts, this.config.language);
    };
    DesktopStrategy.prototype.destroy = function () {
        if (this._pageOpenWidget) {
            this._pageOpenWidget.destroy();
        }
        this._pageLeaveWidgets.forEach(function (widget) {
            widget.destroy();
        });
    };
    return DesktopStrategy;
}());
export { DesktopStrategy };
